import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Client as Styletron } from 'styletron-engine-atomic';
import { Provider as StyletronProvider } from 'styletron-react';
import { Theme, BaseProvider } from '@epo/epods-react-components/lib/Themes';

// Use consistent styling
import 'sanitize.css/sanitize.css';

// Import root app
import { App } from './app/index';
import { HelmetProvider } from 'react-helmet-async';

// EPO stylesheets
import '@epo/epods-react-components/lib/CSS/base-host.min.css';
import '@epo/epods-react-components/lib/CSS/components.min.css';
import '@epo/epods-react-components/lib/CSS/grid.min.css';
import '@epo/epods-react-components/lib/CSS/utilities.min.css';
import '@epo/epods-react-components/lib/CSS/fontface-corporate.min.css';
import '@epo/epods-react-components/lib/CSS/fontface-epoicons-full.min.css';
import '@epo/epods-react-components/lib/CSS/iconography-full.min.css';
import { createStore } from 'redux';
import rootReducer from './store/rootreducer';

const store = createStore(rootReducer);
const MOUNT_NODE = document.getElementById('root') as HTMLElement;
const engine = new Styletron({ prefix: 'CUSTOM_CODE-' });

ReactDOM.render(
    <Provider store={store}>
        <StyletronProvider value={engine}>
            <BaseProvider theme={Theme}>
                <HelmetProvider>
                    <React.StrictMode>
                        <App />
                    </React.StrictMode>
                </HelmetProvider>
            </BaseProvider>
        </StyletronProvider>
    </Provider>,
    MOUNT_NODE,
);
